import { useMemo } from 'react';

import { JobApplicationFormExternalDocType } from '@xing-com/crate-common-graphql-types';
import type { Maybe } from '@xing-com/crate-common-graphql-types';

import type { ExternalDocWithOtherType } from '../types';

type ExternalDocumentsUrls = string[] | undefined;

type UrlsOfExternalDocumentsType = Record<
  JobApplicationFormExternalDocType,
  ExternalDocumentsUrls
> & {
  OTHER: ExternalDocumentsUrls;
};

export const useExternalDocuments = (
  externalDocuments?: Maybe<ExternalDocWithOtherType>[]
): UrlsOfExternalDocumentsType => {
  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
  return <UrlsOfExternalDocumentsType>useMemo(() => {
    const hasExternalDocuments =
      externalDocuments &&
      externalDocuments.length > 0 &&
      !externalDocuments.every((document) => document === null);

    if (!hasExternalDocuments) {
      return { PRIVACY_POLICY: [], TERMS_AND_CONDITIONS: [], OTHER: [] };
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return externalDocuments.reduce((externalDocumentsUrls: any, obj) => {
      const type =
        obj?.type === JobApplicationFormExternalDocType.PrivacyPolicy ||
        obj?.type === JobApplicationFormExternalDocType.TermsAndConditions
          ? obj.type
          : 'OTHER';

      if (!externalDocumentsUrls[type]) externalDocumentsUrls[type] = [];
      if (obj?.url) externalDocumentsUrls[type].push(obj.url);

      return externalDocumentsUrls;
    }, {});
  }, [externalDocuments]);
};
